import { FC } from 'react';
import { CustomerCatalogueContainer } from '../CustomerCatalogueContainer';
import EditBundle from './EditBundle';

export const CustomerEditBundlePage: FC = () => {
  return (
    <CustomerCatalogueContainer>
      <EditBundle />
    </CustomerCatalogueContainer>
  );
};
